import type {CustomerPersonIdentificationTypeCodeEnum} from './CustomerPersonIdentificationTypeCodeEnum';

/**
 * @deprecated
 */
export type PersonIdentification = {
  uuid: string;
  code: string | null;
  validTill: string | null;
  identificationIssuer: string | null;
  note: string | null;
  typeCode: CustomerPersonIdentificationTypeCodeEnum;
};
